import type { Types as Skola24Types } from '../types';
import type { OutTypes } from './schedule';

export default function (
  teachers: Skola24Types.teacher[],
  warnings: string[],
  errors:   string[]
): OutTypes.teacher[] {

  return teachers.map(x => ({
    ids:         x.PK.toString(),
    displayName: x.FirstName && x.LastName ? x.FirstName + ' ' + x.LastName : x.ID
  }));
}
